import { Row, Col, NavItem } from 'react-bootstrap';
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { authKey, GET_TRANSPORTER_CONSIGNMENT_DATA, CREATE_CONSIGNMENT, GET_STAKEHOLDERS_VEHICLE_DRIVER_BY_URN, GET_STAKEHOLDER_BASIC_DETAILS_URN, PRINT_DOWNLOAD_DATA, GET_USER_DETAILS, GET_URN_LIST, GET_VEHICLE_DETAILS_BY_REG_NO, GET_DRIVER_DETAILS_BY_LICENSE_NO } from '../../../common/URLs';
import { PROD, PIT_ROLES, WEIGHT_ERROR, BASIC_DATE_FORMAT, DRIVING_LICENSE, API_DATE_FORMAT } from '../../../common/constants';
import { toast } from 'react-toastify';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import * as React from 'react';
import { useState, useRef, useEffect } from 'react';
import './consignmentScreen.css';
// import DatePicker from "react-datepicker";
import moment from 'moment';
import { ConfirmPopover } from '../../../preregcamps/confirmPopover/confirmPopover';
import { confirmAlert } from 'react-confirm-alert';
import jwt from 'jwt-decode';
import './chippingConsignmentCreation.css';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { loaderService } from '../../../common/custom-loader/loader-service';
import { KeyboardArrowLeftRounded } from '@mui/icons-material';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { Fab, IconButton, FormHelperText, Typography, Card, CardContent, Container, TextField, Grid, Box, Stack, Checkbox, Tooltip, FormLabel, RadioGroup, FormControlLabel, Radio, Paper } from '@mui/material';
import Badge from 'react-bootstrap/Badge';
import { VALIDATION, capitalizeFunction, mobileNumberValidation, nameValidation } from '../../../common/commonValidations';
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import { useTranslation } from "react-i18next";
import { handleNumberFieldFocus } from '../../../common/commonFunction';
import { AddIcon, ClearSearchIcon, CloseIcon, PrintIcon, SaveIcon } from '../../../common/icons';
import apiClient from '../../../axios';
import { FileUploadMUI } from '../../../common/fileUpload/fileUploadMUI';


export default function ChippingConsignmentCreation() {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [consignmentDetails, setconsignmentDetails] = useState([]);
    const [driverList, setDriverList] = useState([]);
    const [vehicleList, setVehicleList] = useState([]);
    const [stakeHolder, setStakeHolder] = useState([]);
    const [selectedUrn, setSelectedUrn] = useState('');
    const decoded = jwt(getLocalStorageItem('id_token'));
    const [userDetails, setUserDetails] = useState();
    const [emailId, setEmailId] = useState();
    const [isApiCalled, setIsApiCalled] = useState(false);
    const [characterLimit] = useState(500);
    let regex = /[-’/`~!#*$@_%+=^&(){}[\]|;:”<>?\\]/g;
    const [otherDriverLicense, setOtherDriverLicense] = useState("");

    useEffect(() => {
        if (getLocalStorageItem('id_token')) {
            const decoded = jwt(getLocalStorageItem('id_token'));
            setSelectedUrn(decoded.extension_URN);

            const email = decoded.emails?.[0];
            setEmailId(email);

        }
    }, [getLocalStorageItem('id_token')]);


    useEffect(() => {
        getconsignmentDetails();
    }, []);



    useEffect(() => {
        if (emailId) {
            getUserDetails();
        }
    }, [emailId]);

    function getUserDetails() {
        apiClient
            .post(GET_USER_DETAILS,
                {
                    "emailAddress": emailId
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setUserDetails(response.data);
            })
            .catch(function (error) {
                console.log(error);
                toast.error(error.message);

            });
    }



    const getconsignmentDetails = (urn, date) => {
        //console.log("in api details");
        // setconsignmentDetails([])
        // let dateVal = Moment(date).format("YYYY-MM-DD");
        //console.log(dateVal);
        let data = {
            "pickUpDate": date ? date : '',
            "stakeholderUrn": decoded.extension_URN ? decoded.extension_URN : urn ? urn : ''
        }
        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
        loaderService.showLoader();
        apiClient
            .post(GET_TRANSPORTER_CONSIGNMENT_DATA, data, { headers })
            .then(res => {
                // res.data.consignmentDataList?.forEach((row, index) => {
                //     row.srno = index;
                // })
                setconsignmentDetails(res.data.consignmentDataList)
                loaderService.hideLoader();
            })
            .catch(function (err) {
                console.log(err);
                loaderService.hideLoader();
                toast.error(err.message);

            });
    };

    const getDriverDetails = () => {
        let data = {

            "urn": selectedUrn ? selectedUrn : 'URN',
            "type": "Transporter"

        }
        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
        apiClient
            .post(GET_STAKEHOLDERS_VEHICLE_DRIVER_BY_URN, data, { headers })
            .then(res => {
                setDriverList(res.data.driverList)
                setVehicleList(res.data.vehicleList)
            })
            .catch(function (err) {
                console.log(err);
                toast.error(err.message);

            });
    };

    const getOwnerDetails = () => {

        let data = {

            // "urn": "URN-DEVTR00153",
            "urn": selectedUrn ? selectedUrn : 'URN',
            "type": "hit"

        }
        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
        apiClient
            .post(GET_STAKEHOLDER_BASIC_DETAILS_URN, data, { headers })
            .then(res => {

                setStakeHolder(res.data.stakeHolders);
            })
            .catch(function (err) {
                console.log(err);
                toast.error(err.message);
            });
    };

    const [driverName, setDriverName] = useState("");
    const [driverNameError, setDriverNameError] = useState("");

    const [driverlicensenumber, setDriverlicensenumber] = useState("");
    const [driverlicensenumberError, setDriverlicensenumberError] = useState("");

    const [driverContact, setDriverContact] = useState("");
    const [driverContactError, setDriverContactError] = useState("");

    const [comments, setComments] = useState("");

    const [vehicleNo, setVehicleNo] = useState("");
    const [vehicleNoError, setVehicleNoError] = useState("");

    const [vehicleCapacity, setVehicleCapacity] = useState("");
    const [vehicleCapacityError, setVehicleCapacityError] = useState("");

    const [pickUpdate, setPickUpDate] = React.useState(null);
    const [logModalOpen, setLogModalOpen] = useState(false);
    const [cofirmMessage, setConfirmMessage] = useState("");

    const [showErrorMsg, setShowErrorMsg] = React.useState("");
    const [open, setOpen] = React.useState(false);
    const [open1, setOpen1] = React.useState(false);
    const [consignmentData, setConsignmentData] = React.useState();
    const [selectedConsignments, setSelectedConsignments] = React.useState([]);
    const [selectedConsignmentId, setSelectedConsignmentId] = React.useState(null);
    const [totalQuantity, setTotalQuantity] = React.useState(0);
    const [downloadConsignment, setDownloadConsignment] = React.useState();
    const [urnList, setUrnList] = useState([]);
    const [noUrnError, setNoUrnError] = useState("");
    const [msg, setMsg] = useState('');

    const [confirmOpen, setConfirmOpen] = useState(false);
    const handleConfirmOpen = () => setConfirmOpen(true);
    const handleConfirmClose = () => setConfirmOpen(false);
    const [documentsArray, setDocumentsArray] = useState([]);
    const [totalScheduleQty, setTotalScheduleQty] = useState();
    const [details, setDetails] = useState({
        vehicleType: "",
        vehicleOwnerType: "",
        grossVehicleWeight: "",
        unladenWeight: "",
        vehicleMake: "",
        vehicleModel: "",
        vehicleAge: "",
        vehicleRegistrationNo: "",
        registrationEndDate: new Date(),
        insuranceNo: "",
        insuranceEnddate: new Date(),
        puccNo: "",
        puccEndDate: new Date(),
        fitnessNo: "",
        fitnessEndDate: new Date(),
        driverName: "",
        licenseNo: "",
        driverContactNo: "",
        licenceIssueDate: new Date(),
        licenceValidityEnddate: new Date(),
        // expectedWeight: "",
        dbsScheduleList: []
    });

    const [errorMessage, setErrorMessage] = useState({
        urn: "",
        landId: "",
        name: "",
        mobileNo: "",
        address: "",
        destinationStakeholderType: "",
        destinationStakeholderUrn: "",
        vehicleType: "",
        vehicleOwnerType: "",
        grossVehicleWeight: "",
        unladenWeight: "",
        vehicleMake: "",
        vehicleModel: "",
        vehicleAge: "",
        vehicleRegistrationNo: "",
        registrationEndDate: "",
        insuranceNo: "",
        insuranceEnddate: "",
        puccNo: "",
        puccEndDate: "",
        fitnessNo: "",
        fitnessEndDate: "",
        driverName: "",
        licenseNo: "",
        driverContactNo: "",
        licenceIssueDate: "",
        licenceValidityEnddate: "",
        vehicleRegistrationDoc: "",
        vehicleInsuranceDoc: "",
        vehiclePuccDoc: "",
        vehicleFitnessDoc: "",
        // expectedWeight: ""
    });

    const onUploadCallBack = (docArray) => {
        setDocumentsArray(docArray);
    }

    const handleClose = () => {
        setShowErrorMsg("");
        setOpen(false);
    };

    const handleClose1 = () => {
        // setShowErrorMsg("")
        setOpen1(false);
        setOpen(true);
    };

    const handleYes = () => {

        setOpen1(false);
        setOpen(true);
        handleSplit();
    }

    const handleSplit = async () => {

        let vehicalCapacityVal = Number(vehicleCapacity);
        let newConsigments = [];
        let consignmentSourceDetails = [];
        let schedulePlanData = null;
        let consignmentCreationRequest = {

            "consignmentType": stakeHolder[0].categoryName,
            "materialType": selectedConsignments[0]?.inventoryType === "RB" ? "RawBamboo" : selectedConsignments[0]?.inventoryType === "CB" ? "ChipBamboo" : "",
            "typeOfLoading": "FTL",
            "consignmentScheduleDate": selectedConsignments[0].scheduledPickupDate,
            "consignmentSourceType": "Transporter",
            // "consignmentSourceType": selectedConsignments[0].pickUpLocationType,
            "consignmentSourceUrn": selectedUrn,
            "scheduledWeight": totalQuantity,
            "consignmentWeight": vehicalCapacityVal,
            "scheduleDeliveryTimestamp": selectedConsignments[0].scheduledDeliveryDate,
            "consignmentDestinationStakeholderUrn": selectedConsignments[0].deliveryLocationURN,
            "consignmentDestinationType": selectedConsignments[0].deliveryLocationType,
            "consignmentDestinationName": selectedConsignments[0].deliveryLocationName,
            "consignmentDestinationLocationName": selectedConsignments[0].deliveryLocationName,
            "consignmentDestinationLocationAddress": selectedConsignments[0].deliveryLocationAddress,
            "consignmentOwnerName": stakeHolder[0].name,
            "consignmentOwnerContactNo": stakeHolder[0].mobileNo,
            "vehicleType": details?.vehicleType,
            "vehicleOwnerType": details?.vehicleOwnerType,
            "grossVehicleWeight": details?.grossVehicleWeight,
            "unladenWeight": details?.unladenWeight,
            "vehicleMakeModel": details?.vehicleModel,
            "vehicleMake": details?.vehicleMake,
            "vehicleModel": details?.vehicleModel,
            "vehicleAge": details?.vehicleAge,
            "vehicleRegFileId": documentsArray?.find((item) => item.documentType === "VehicleRegistration")?.documentBlobName,
            "vehicleRegFileName": documentsArray?.find((item) => item.documentType === "VehicleRegistration")?.documentName,
            "regEndDate": details?.registrationEndDate,
            "vehicleRegNo": vehicleNo === "other" ? details?.vehicleRegistrationNo : vehicleNo,
            "driverName": details?.driverName,
            "driverLicenseNo": driverlicensenumber == "other" ? otherDriverLicense : driverlicensenumber,
            "driverContact": details?.driverContactNo,
            "licenseIssueDate": details?.licenceIssueDate,
            "licenseEndDate": details?.licenceValidityEnddate,
            "licenseFileId": documentsArray?.find((item) => item.documentType === DRIVING_LICENSE)?.documentBlobName,
            "licenseFileName": documentsArray?.find((item) => item.documentType === DRIVING_LICENSE)?.documentName,
            "insuranceNo": details?.insuranceNo,
            "insuranceFileId": documentsArray?.find((item) => item.documentType === "VehicleInsurance")?.documentBlobName,
            "insuranceEnddate": details?.insuranceEnddate,
            "insuranceFileName": documentsArray?.find((item) => item.documentType === "VehicleInsurance")?.documentName,
            "puccNo": details?.puccNo,
            "puccEndDate": details?.puccEndDate,
            "puccFileId": documentsArray?.find((item) => item.documentType === "VehiclePUCC")?.documentBlobName,
            "puccFileName": documentsArray?.find((item) => item.documentType === "VehiclePUCC")?.documentName,
            "fitnessNo": details?.fitnessNo,
            "fitnessEndDate": details?.fitnessEndDate,
            "fitnessFileId": documentsArray?.find((item) => item.documentType === "FitnessNo")?.documentBlobName,
            "fitnessFileName": documentsArray?.find((item) => item.documentType === "FitnessNo")?.documentName,
            "vehicleCapacity": vehicleCapacity,
            "consignmentComments": comments,
            "fiscalYear": selectedConsignments[0].fiscalYear,
            "month": selectedConsignments[0].month,
            "transporterServicePO": selectedConsignments[0].transporterServicePO
        };
        selectedConsignments.forEach(element => {
            if (vehicalCapacityVal - Number(element.scheduleWeight) >= 0) {
                vehicalCapacityVal = vehicalCapacityVal - Number(element.scheduleWeight);
                // consignmentDetails.forEach(ele=>{
                // if(ele.srno===element.srno){
                //     ele.vechileregistration = vehicleNo;
                //     ele.drivername = driverName;
                //     ele.driverlicensenumber = driverlicensenumber;
                //     ele.drivercontact = driverContact;
                //     ele.comments=comments;  
                //     ele.typeofloading = "FTL";
                //     ele.conQnty = ele.quantity;
                //   ele.consignmentNum ="001";
                //   ele.checkBoxChecked = false;  
                let conSourceData = {
                    "weeklyScheduleNumber": element.scheduleNumber,
                    "scheduleLineNumber": element.scheduleLineNo,
                    "scheduleId": element.id,
                    "weightToBeLifted": element.scheduleWeight,
                    "sourceType": "LLE",
                    "sourceStakeholderUrn": element.pickUpLocationURN,
                    "sourceName": element.sourceName,
                    "sourceLocationName": element.pickUpLocationName,
                    "sourceLocationAddress": element.pickUpLocationAddress,
                    "sourceStakeholderPo": element.growerPO,
                    "landId": element.landId,

                }
                consignmentSourceDetails.push(conSourceData);
                // }
                // })
            } else if (vehicalCapacityVal - Number(element.scheduleWeight) < 0) {


                /// consignmentDetails.forEach(ele=>{
                //if(ele.srno===element.srno){
                if (vehicalCapacityVal > 0) {
                    let conSourceData = {
                        "weeklyScheduleNumber": element.scheduleNumber,
                        "scheduleLineNumber": element.scheduleLineNo,
                        "scheduleId": element.id,
                        "scheduleStakeholderUrn": element.scheduleStakeholderUrn,
                        "weightToBeLifted": vehicalCapacityVal,
                        "sourceType": "LLE",
                        "sourceStakeholderUrn": element.pickUpLocationURN,
                        "sourceName": element.sourceName,
                        "sourceLocationName": element.pickUpLocationName,
                        "sourceLocationAddress": element.pickUpLocationAddress,
                        "sourceStakeholderPo": element.growerPO,
                        "landId": element.landId



                    }
                    //ele.quantity = vehicalCapacityVal;
                    consignmentSourceDetails.push(conSourceData);
                    schedulePlanData = {
                        "monthlyPlanId": element.monthlyPlanId,
                        "scheduleId": element.id,
                        "scheduleStakeholderType": "Transporter",
                        "scheduleStakeholderUrn": element.scheduleStakeholderUrn,
                        "weeklyScheduleNumber": element.scheduleNumber,
                        "scheduleLineNumber": element.scheduleLineNo,
                        "schedulePickupDate": element.scheduledPickupDate,
                        "scheduleRbCbQuantity": Number(element.scheduleWeight) - vehicalCapacityVal,
                        "firstPartyUrn": element.pickUpLocationURN,
                        "firstPartyType": element.pickUpLocationType,
                        "firstPartyName": element.pickUpName,
                        "firstPartyContactNo": element.pickUpContactNo,
                        "firstPartyLocationName": element.pickUpLocationName,
                        "firstPartyLocationAddress": element.pickUpLocationAddress,
                        "secondPartyUrn": element.deliveryLocationURN,
                        "secondPartyType": element.deliveryLocationType,
                        "secondPartyName": element.deliveryName,
                        "secondPartyContactNo": element.deliveryContactNo,
                        "secondPartyLocationName": element.deliveryLocationName,
                        "secondPartyLocationAddress": element.deliveryLocationAddress,
                        "scheduledDeliveryDate": element.scheduledDeliveryDate,
                        "isActualScheduleLine": false,
                        "isConsignmentCreated": false,
                        "chippingQuantity": 0,
                        "loadingQuantity": Number(element.scheduleWeight) - vehicalCapacityVal,
                        "poStpoNumber": element.growerPO,
                        "fiscalYear": element.fiscalYear,
                        "month": element.month
                    }
                }
                //}
                //})

            }
        })
        let createConsignment = {
            "consignmentData": { ...consignmentCreationRequest, "consignmentSourceDetails": consignmentSourceDetails },
            "schedulePlanData": schedulePlanData
        }
        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
        loaderService.showLoader();
        return await apiClient
            .post(CREATE_CONSIGNMENT, createConsignment, { headers })
            .then(res => {
                getconsignmentDetails(selectedUrn, null);
                setMsg(res.data);
                setDetails({
                    vehicleType: "",
                    vehicleOwnerType: "",
                    grossVehicleWeight: "",
                    unladenWeight: "",
                    vehicleMake: "",
                    vehicleModel: "",
                    vehicleAge: "",
                    vehicleRegistrationNo: "",
                    registrationEndDate: new Date(),
                    insuranceNo: "",
                    insuranceEnddate: new Date(),
                    puccNo: "",
                    puccEndDate: new Date(),
                    fitnessNo: "",
                    fitnessEndDate: new Date(),
                    expectedWeight: "",
                    driverName: "",
                    licenseNo: "",
                    driverContactNo: "",
                    licenceIssueDate: new Date(),
                    licenceValidityEnddate: new Date(),
                    dbsScheduleList: []
                });

                setDocumentsArray([]);
                setVehicleNo("");
                setVehicleCapacity("");
                setDriverlicensenumber("");
                setOtherDriverLicense("");
                setComments("");
                setSelectedConsignments([]);
                setTotalQuantity(0);
                setShowErrorMsg('');
                setOpen(false);
                loaderService.hideLoader();
            })
            .catch(function (err) {
                console.log(err);
                loaderService.hideLoader();
                toast.error(err.message);
            });
        //setconsignmentDetails([...consignmentDetails, ...newConsigments])
        setVehicleCapacity("");
        setVehicleNo("");
        setDriverlicensenumber("");
        setOtherDriverLicense("");
        setDriverContact("");
        setDriverName("");
        setComments("");
    }

    useEffect(() => {
        if (msg) {
            if (msg.isSuccess === true) {
                setSelectedConsignments([]);
                toast.success(msg?.message)
                setOpen(false);
                // handleLogModalOpen1();
            } else {
                toast.error(msg?.message ? msg?.message : "Error")
                setOpen(true);
                // handleLogModalClose();
            }
        }
    }, [msg]);

    const handleSave = () => {
        //let totalQuantityVal = selectedConsignments.reduce((total, e) => (e.splitQty ? Number(e.splitQty) : e.quantity) + total, 0)
        if (vehicleNo === "") {
            setVehicleNoError("Please fill Vehicle Number");
            return;
        }
        if (vehicleNo === "other") {
            if (!details.vehicleType) {
                setErrorMessage({ ...errorMessage, vehicleType: "Enter vehicle type" })
                return;
            }
            if (!details.vehicleOwnerType) {
                setErrorMessage({ ...errorMessage, vehicleOwnerType: "Enter ownership type" })
                return;
            }
            if (!details.grossVehicleWeight) {
                setErrorMessage({ ...errorMessage, grossVehicleWeight: "Enter gross vehicle weight" })
                return;
            }
            if (!details.unladenWeight) {
                setErrorMessage({ ...errorMessage, unladenWeight: "Enter unladen weigth" })
                return;
            }
            if (!details.vehicleRegistrationNo || !VALIDATION.registrationNumberValidation(details.vehicleRegistrationNo)) {
                setErrorMessage({ ...errorMessage, vehicleRegistrationNo: "Enter valid vehicle registration number" })
                return;
            }
            var regDoc = documentsArray && documentsArray.filter((item) => item.documentType === "VehicleRegistration" && item.isActive == 1);
            if (!regDoc || regDoc.length == 0) {
                setErrorMessage({ registrationDocError: "Please upload Registration document" });
                toast.error("Please upload Registration document");
                return;
            }
            if (!details.insuranceNo) {
                setErrorMessage({ ...errorMessage, insuranceNo: "Enter insurance no" })
                return;
            }
            var insuranceDoc = documentsArray && documentsArray.filter((item) => item.documentType === "VehicleInsurance" && item.isActive == 1);
            if (!insuranceDoc || insuranceDoc.length == 0) {
                setErrorMessage({ insurenaceDocError: "Please upload Insurance document" });
                toast.error("Please upload Insurance document");
                return;
            }
            if (!details.puccNo) {
                setErrorMessage({ ...errorMessage, puccNo: "Enter pucc number" })
                return;
            }
            var puccDoc = documentsArray && documentsArray.filter((item) => item.documentType === "VehiclePUCC" && item.isActive == 1);
            if (!puccDoc || puccDoc.length == 0) {
                setErrorMessage({ puccDocError: "Please upload PUCC document" });
                toast.error("Please upload PUCC document");
                return;
            }
            if (!details.fitnessNo) {
                setErrorMessage({ ...errorMessage, fitnessNo: "Enter fitness number" })
                return;
            }
            var fitnessDoc = documentsArray && documentsArray.filter((item) => item.documentType === "FitnessNo" && item.isActive == 1);
            if (!fitnessDoc || fitnessDoc.length == 0) {
                setErrorMessage({ fitnessDocError: "Please upload Fitness document" });
                toast.error("Please upload Fitness document");
                return;
            }
        }
        if (vehicleCapacity === "") {
            setVehicleCapacityError("Please fill Vehicle Capacity");
            return;
        }
        if (driverlicensenumber === "" || (driverlicensenumber === "other" && !otherDriverLicense)) {
            setDriverlicensenumberError("Please fill Driver License Number");
            return;
        }
        if (!details.driverName) {
            setErrorMessage({ driverName: "Please fill Driver Name" });
            return;
        }
        if (!details.driverContactNo) {
            setErrorMessage({ driverContactNo: "Please fill Driver Contact Details" });
            return;
        }
        if (details?.driverContactNo?.length < 10) {
            setErrorMessage({ driverContactNo: "Please enter 10 digit mobile number" });
            return;
        }
        var licenseDoc = documentsArray && documentsArray.filter((item) => item.documentType === DRIVING_LICENSE && item.isActive == 1);
        if (driverlicensenumber === "other" && (!licenseDoc || licenseDoc.length == 0)) {
            setErrorMessage({ drivingLicenseDocError: "Please upload Driving License document" });
            toast.error("Please upload Driving License document");
            return;
        }
        if (Number(vehicleCapacity) > totalQuantity) {
            setShowErrorMsg("Please Add more consignments to reach vehicle capacity")
        } else if (Number(vehicleCapacity) < totalQuantity) {
            setOpen(false);
            setOpen1(true);
        } else {
            handleConfirmOpen();
        }
    };

    const handleDateChange = (e, name) => {
        setDetails({ ...details, [name]: e.format(API_DATE_FORMAT) })
    }

    const handlePickupDateChange = (e) => {
        setPickUpDate(e?.format("YYYY-MM-DD"));
        setSelectedConsignments([]);
        setTotalQuantity(0);
        getconsignmentDetails(selectedUrn, e?.format("YYYY-MM-DD"));
    }

    const onValueUrn = (e) => {
        setSelectedUrn(e.target.value);
        setSelectedConsignments([]);
        setTotalQuantity(0);
        getconsignmentDetails(e.target.value, pickUpdate);
        setNoUrnError("");
    }

    const viewurn = (e, selectedConsignmentId) => {
        if (selectedConsignments.length > 0 && selectedUrn) {
            getDriverDetails();
            getOwnerDetails();
            setOpen(true);
        }
        else {
            setNoUrnError("Please an Stakeholder URN");
        }
    }

    // const onConfirm = () => {
    //     handleConfirmClose();
    //     handleSplit();
    // }

    const onConfirm = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await handleSplit();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setConfirmOpen(false);
            setIsApiCalled(false);
        }
    };


    const onSaveButtonClick = () => {
        // handleConfirmOpen();
        handleSave();
    }


    const clearSearch = (e) => {
        e.preventDefault();
        setPickUpDate(null);
        setSelectedUrn('');
        getconsignmentDetails('', null);
    }


    // const updateSelectedRows = (event, row) => {
    //     let selectedRowsTemp = selectedConsignments;
    //     if (event.target.checked) {
    //         selectedRowsTemp.push(row)
    //     } else {
    //         selectedRowsTemp = selectedRowsTemp.filter(e => {
    //             if (e.srno === row.srno) {
    //                 return false;
    //             }
    //             return true;
    //         })
    //     }
    //     let totalQuantityVal = selectedRowsTemp.reduce((total, e) => Number(e.scheduleWeight) + total, 0)
    //     setTotalQuantity(totalQuantityVal);
    //     selectedRowsTemp.sort((a, b) => {
    //         if (Number(a.scheduleWeight) > Number(b.scheduleWeight)) {
    //             return -1;
    //         } else {
    //             return 1;
    //         }
    //     });
    //     setSelectedConsignments(selectedRowsTemp)
    // }

    const updateSelectedRows = (event, row) => {
        setSelectedConsignments(prevSelectedRows => {
            if (event.target.checked) {
                // Add the entire row object to selectedRows if checked and update totalQty
                const newSelectedRows = [...prevSelectedRows, row];
                updateTotalQty(newSelectedRows);
                newSelectedRows.sort((a, b) => {
                    if (Number(a.scheduleWeight) > Number(b.scheduleWeight)) {
                        return -1;
                    } else {
                        return 1;
                    }
                });
                return newSelectedRows;
            } else {
                // Remove the row object from selectedRows if unchecked and update totalQty
                const newSelectedRows = prevSelectedRows.filter(r => r.id !== row.id);
                updateTotalQty(newSelectedRows);
                newSelectedRows.sort((a, b) => {
                    if (Number(a.scheduleWeight) > Number(b.scheduleWeight)) {
                        return -1;
                    } else {
                        return 1;
                    }
                });
                return newSelectedRows;
            }
        });
    };

    // Function to update the total quantity
    const updateTotalQty = (selectedRows) => {
        const total = selectedRows.reduce((total, e) => Number(e.scheduleWeight) + total, 0);
        setTotalQuantity(total);
    };

    const updateVehicleDetails = (e) => {
        e.target.value.length > 0 && setVehicleNoError("");
        setVehicleNo(e.target.value);
        // setSelectedUrn(e.target.value);
        let vehicleSelected = vehicleList.find(vehicle => vehicle.registrationNo === e.target.value)
        setVehicleCapacity(e.target.value !== "other" ? (Number(vehicleSelected?.grossVehicleWeight) - Number(vehicleSelected?.unladenWeight)) / 1000 : "");
        e.target.value !== "other" && setDetails({
            vehicleType: "",
            vehicleOwnerType: "",
            grossVehicleWeight: "",
            unladenWeight: "",
            vehicleMake: "",
            vehicleModel: "",
            vehicleAge: "",
            vehicleRegistrationNo: "",
            registrationEndDate: new Date(),
            insuranceNo: "",
            insuranceEnddate: new Date(),
            puccNo: "",
            puccEndDate: new Date(),
            fitnessNo: "",
            fitnessEndDate: new Date(),
            expectedWeight: "",
            driverName: "",
            licenseNo: "",
            driverContactNo: "",
            licenceIssueDate: new Date(),
            licenceValidityEnddate: new Date(),
            dbsScheduleList: []
        });

        if (vehicleSelected?.vehicleRegistrationFileId) {
            const vehicleDoc = {
                id: null,
                documentType: "VehicleRegistration",
                documentName: vehicleSelected?.vehicleRegistrationFileName,
                documentBlobName: vehicleSelected?.vehicleRegistrationFileId,
                documentContainerName: "pit",
                isActive: 1,
            };
            setDocumentsArray((prev) => {
                const i = prev.findIndex(
                    (d) => d?.documentType === "VehicleRegistration"
                );
                if (i !== -1) {
                    // update only that object; keep others as-is
                    const copy = [...prev];
                    copy[i] = { ...copy[i], ...vehicleDoc };
                    return copy;
                }
                // add it; keep existing docs
                return [...prev, vehicleDoc];
            });
        }
    }

    const updateDriverDetails = (e) => {
        e.target.value.length > 0 && setDriverlicensenumberError("");
        setDriverlicensenumber(e.target.value);
        let driverSelected = driverList?.find(driver => driver.driverLicenseId === e.target.value)
        e.target.value == "other" ? setDetails({ ...details, driverName: "", driverContactNo: "" }) : setDetails({ ...details, driverName: driverSelected?.driverName, driverContactNo: driverSelected?.driverContactNo });

        if (driverSelected?.drivingLicenseFileId) {
            const driverDoc = {
                id: null,
                documentType: DRIVING_LICENSE,
                documentName: driverSelected?.drivingLicenseFileName,
                documentBlobName: driverSelected?.drivingLicenseFileId,
                documentContainerName: "pit",
                isActive: 1,
            };
            setDocumentsArray((prev) => {
                const i = prev.findIndex(
                    (d) => d?.documentType === DRIVING_LICENSE
                );
                if (i !== -1) {
                    // update only that object; keep others as-is
                    const copy = [...prev];
                    copy[i] = { ...copy[i], ...driverDoc };
                    return copy;
                }
                // add it; keep existing docs
                return [...prev, driverDoc];
            });
        }
    }

    const setSplitQty = (val, row) => {
        row['splitQty'] = val;

    }

    const getconsignmentdata = (num) => {
        loaderService.showLoader();
        apiClient
            .post(PRINT_DOWNLOAD_DATA,
                {
                    "printDataByNumber": num,
                    "printDetailsType": "hit_consignment"
                },
                {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),

                        Accept: 'application/pdf'
                    }
                }, null
            )
            .then((response) => {
                setDownloadConsignment(response.data);
                const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                let iframe = document.createElement('iframe');
                document.body.appendChild(iframe);
                iframe.style.display = 'none';
                iframe.src = url;
                iframe.onload = function () {
                    setTimeout(function () {
                        iframe.focus();
                        iframe.contentWindow.print();
                    }, 1);
                };
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }
    useEffect(() => {
        getUrnList();

    }, []);

    function getUrnList() {
        loaderService.showLoader()
        apiClient
            .post(GET_URN_LIST,
                {
                    "stakeholderType": "Transporter"
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setUrnList(response.data.urnNoList);
                loaderService.hideLoader()
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader()
                toast.error(error.message);
            });
    }

    function searchConsignmentData(e) {
        e.preventDefault();
        getconsignmentDetails(selectedUrn, pickUpdate);
    }

    const columns = [
        {
            field: 'rowSelect',
            headerName: '',
            width: 50,
            renderCell: (params) => (
                <Checkbox name="rowSelect" disabled={params.row.consignmentNumber ? true : false} checked={selectedConsignments.some(r => r.id === params.row.id)} value={params.row.checkBoxChecked} onChange={(e) => updateSelectedRows(e, params.row)} />
            ),
        },
        { field: 'scheduleNumber', headerName: 'Schedule Number', width: 250 },
        { field: 'scheduleLineNo', headerName: 'Schedule Line', width: 120 },
        { field: 'scheduleWeight', headerName: 'Balance Quantity(MT)', width: 160 },
        { field: 'transporterServicePO', headerName: 'Service PO Number', width: 150 },
        { field: 'pickUpLocationURN', headerName: 'Pick-Up Location URN', width: 180 },
        { field: 'pickUpLocationName', headerName: 'Pick-Up Location Name', width: 180 },
        { field: 'pickUpLocationAddress', headerName: 'Pick-Up Location Address', width: 180 },
        {
            field: 'scheduledPickupDate', headerName: 'Scheduled pick-up date', width: 180,
            valueFormatter: params => params?.value && moment(params?.value).format("DD/MM/YYYY"),
        },
        // {
        //     field: 'actualPickupDate', headerName: 'Actual Pick-Up Date', width: 180,
        //     valueFormatter: params => params?.value && moment(params?.value).format("DD/MM/YYYY"),
        // },
        { field: 'deliveryLocationURN', headerName: 'Delivery Location URN', width: 180 },
        { field: 'deliveryLocationName', headerName: 'Delivery Location Name', width: 180 },
        { field: 'deliveryLocationAddress', headerName: 'Delivery Location Address', width: 180 },
        {
            field: 'scheduledDeliveryDate', headerName: 'Scheduled Delivery Date', width: 180,
            valueFormatter: params => params?.value && moment(params?.value).format("DD/MM/YYYY"),
        },
        {
            field: 'actualDeliveryDate', headerName: 'Actual Delivery Date', width: 180,
            valueFormatter: params => params?.value && moment(params?.value).format("DD/MM/YYYY"),
        },
        { field: 'inventoryType', headerName: 'Type Of Inventory', width: 150 },
        { field: 'landId', headerName: 'Land ID', width: 150 },
        { field: 'loadingType', headerName: 'Type Of Loading(FTL/LTL)', width: 150 },
        { field: 'vehicleRegistration', headerName: 'Vehicle Registration', width: 150 },
        { field: 'driverName', headerName: 'Driver Name', width: 150 },
        { field: 'driverID', headerName: 'Driver License Number', width: 180 },
        { field: 'driverContact', headerName: 'Driver Contact', width: 150 },
        { field: 'scheduledConsignmentWeight', headerName: 'Consignment Quantity (MT)', width: 150 },
        { field: 'consignmentNumber', headerName: 'Consignment No', width: 150 },
        { field: 'comment', headerName: 'Consignment Comments(if any)', width: 150 },
        {
            field: 'Action', width: 120,
            renderCell: (params) => {
                return (
                    <Tooltip title="Print">
                        <IconButton
                            variant="contained"
                            color="primary"
                            onClick={() => getconsignmentdata(params.row.consignmentNumber)}
                            hidden={params.row.consignmentNumber === null}
                        >
                            <PrintIcon />
                        </IconButton>
                    </Tooltip>
                );
            }
        },
    ];

    const consDetailsCol = [
        { field: 'pickUpLocationName', headerName: 'Scheduled Pick-Up Location', flex: 1 },
        { field: 'deliveryLocationName', headerName: 'Delivery Location', flex: 1 },
        { field: 'scheduleWeight', headerName: 'Balance Quantity (MT)', flex: 1 },
    ];

    const onTextValueChange = (e) => {
        setComments(VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 500)));
    }

    const handleChange = (e) => {
        setErrorMessage({ ...errorMessage, [e.target.name]: "" });
        setDetails({ ...details, [e.target.name]: e.target.value });
        if (e.target.name === 'grossVehicleWeight') {
            const slicedValue = VALIDATION?.weightsSlicedValue(e.target.value);
            const vehicleWeightValidation = VALIDATION?.weightsValidation(details.vehicleType, slicedValue)
            setDetails({ ...details, [e.target.name]: slicedValue });
            if (slicedValue.length == 0) {
                setErrorMessage({ ...errorMessage, [e.target.name]: 'Please enter Vehicle weight' })
            }
            else if (vehicleWeightValidation) {
                setErrorMessage({ ...errorMessage, [e.target.name]: vehicleWeightValidation })
            }
            else setErrorMessage({ ...errorMessage, [e.target.name]: "" })
        }
        if (e.target.name === 'unladenWeight') {
            setDetails({ ...details, [e.target.name]: VALIDATION.weightsSlicedValue(e.target.value) });
            if ((e.target.value.toString()).length <= 5) {
                setErrorMessage({ ...errorMessage, [e.target.name]: '' })
            } else setErrorMessage({ ...errorMessage, [e.target.name]: WEIGHT_ERROR })
        }

        if (e.target.name === 'vehicleMake') {
            if ((e.target.value.toString()).length > 0) {
                setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 50)) });
                setErrorMessage({ ...errorMessage, [e.target.name]: '' })
            } else {
                setErrorMessage({ ...errorMessage, [e.target.name]: "Please enter Vehicle Make" })
            }
        }
        if (e.target.name === 'vehicleModel') {
            if ((e.target.value.toString()).length > 0) {
                setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 50)) });
                setErrorMessage({ ...errorMessage, [e.target.name]: '' })
            } else setErrorMessage({ ...errorMessage, [e.target.name]: "Please enter Vehicle Model" })
        }
        if (e.target.name === 'vehicleAge') {
            if ((e.target.value.toString()).length > 0) {
                setDetails({ ...details, [e.target.name]: e.target.value.slice(0, 2) });
                setErrorMessage({ ...errorMessage, [e.target.name]: '' })
            } else setErrorMessage({ ...errorMessage, [e.target.name]: "Please enter Vehicle Age" })
        }
        if (e.target.name === 'vehicleRegistrationNo') {
            if ((e.target.value.toString()).length > 0) {
                if (VALIDATION.registrationNumberValidation(e.target.value)) {
                    setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharCapsValidation(e.target.value.slice(0, 50)) });
                } else setErrorMessage({ ...errorMessage, [e.target.name]: 'Please enter valid Registration Number' })

            } else setErrorMessage({ ...errorMessage, [e.target.name]: 'Please enter valid Registration Number' })
        }
        if (e.target.name === 'insuranceNo') {
            if ((e.target.value.toString()).length > 0) {
                setErrorMessage({ ...errorMessage, [e.target.name]: '' })
                setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharCapsValidation(e.target.value.slice(0, 50)) });
            } else setErrorMessage({ ...errorMessage, [e.target.name]: 'Please enter valid Insurance No.' })
        }
        if (e.target.name === 'puccNo') {
            if ((e.target.value.toString()).length > 0) {
                setErrorMessage({ ...errorMessage, [e.target.name]: '' })
                setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharCapsValidation(e.target.value.slice(0, 50)) });
            } else setErrorMessage({ ...errorMessage, [e.target.name]: 'Please enter valid PUCC No.' })
        }
        if (e.target.name === 'fitnessNo') {
            if ((e.target.value.toString()).length > 0) {
                setErrorMessage({ ...errorMessage, [e.target.name]: '' })
                setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharCapsValidation(e.target.value.slice(0, 50)) });
            } else setErrorMessage({ ...errorMessage, [e.target.name]: 'Please enter valid Fitness No.' })
        }
        if (e.target.name === 'driverName') {
            if ((e.target.value.toString()).length > 0) {
                setDetails({ ...details, [e.target.name]: nameValidation(e.target.value.slice(0, 50)) });
                setErrorMessage({ ...errorMessage, [e.target.name]: '' })
            } else {
                setErrorMessage({ ...errorMessage, [e.target.name]: "Please enter Driver Name" })
            }
        }
        if (e.target.name === "driverContactNo") {
            setDetails({ ...details, [e.target.name]: mobileNumberValidation(e.target.value) });
            if (e.target.value.length < 10) {
                setErrorMessage({ ...errorMessage, [e.target.name]: "Please enter 10 digit mobile number" });
            }
            else setErrorMessage({ ...errorMessage, [e.target.name]: "" });
        }
        // if (e.target.name === 'expectedWeight') {
        //     if ((e.target.value.toString()).length > 0) {
        //         setErrorMessage({ ...errorMessage, [e.target.name]: '' })
        //         setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharCapsValidation(e.target.value.slice(0, 10)) });
        //     } else setErrorMessage({ ...errorMessage, [e.target.name]: 'Please enter expected weight' })
        // }
        // if (e.target.name === 'expectedWeight') {
        //     if ((e.target.value.toString()).length < 0) {
        //         setErrorMessage({ ...errorMessage, [e.target.name]: 'Please enter expected weight' })
        //         // setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharCapsValidation(e.target.value.slice(0, 10)) });
        //     }
        //     if ((e.target.value > totalScheduleQty)) {
        //         setErrorMessage({ ...errorMessage, [e.target.name]: 'Expected weight cannot be greater than total weight of selected schedules' })
        //     }
        //     else {
        //         setErrorMessage({ ...errorMessage, [e.target.name]: '' })
        //         setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharCapsValidation(e.target.value.slice(0, 10)) });
        //     }
        // }
        if (e.target.name === 'licenseNo') {
            if ((e.target.value.toString()).length > 0) {
                setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharCapsValidation(e.target.value.slice(0, 20)) });
                setErrorMessage({ ...errorMessage, [e.target.name]: '' })
            } else {
                setErrorMessage({ ...errorMessage, [e.target.name]: "Please enter license number" })
            }
        }
        // if (e.target.name === 'licenseNo') {
        //     if ((e.target.value.toString()).length > 0 || validateLicenseNumber(e.target.value)) {
        //         setErrorMessage({ ...errorMessage, [e.target.name]: '' })
        //         setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharCapsValidation(e.target.value.slice(0, 16)) });
        //     } else {
        //         setErrorMessage({ ...errorMessage, [e.target.name]: 'Invalid driving license number format.' })
        //     }
        // }

    }

    useEffect(() => {
        if (details?.vehicleRegistrationNo) {
            getVehicleDetailsByRegNo();
        }
    }, [details?.vehicleRegistrationNo]);

    useEffect(() => {
        if (otherDriverLicense) {
            getDetailsByLicenseNo();
        }
    }, [otherDriverLicense]);

    useEffect(() => {
        if (details?.grossVehicleWeight && details?.unladenWeight) {
            setVehicleCapacity(vehicleNo === "other" ? (Number(details?.grossVehicleWeight) - Number(details?.unladenWeight)) / 1000 : "");
        }
    }, [details?.grossVehicleWeight, details?.unladenWeight]);



    const getVehicleDetailsByRegNo = () => {
        loaderService.showLoader();
        apiClient.post(GET_VEHICLE_DETAILS_BY_REG_NO,
            {
                "vehicleRegNo": details?.vehicleRegistrationNo
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                // setVehicleInfo(response.data.vehicleInfo);
                const tempArr = []
                if (response.data.vehicleInfo?.vehicleRegFileId) {
                    tempArr.push({
                        id: null,
                        documentType: "VehicleRegistration",
                        documentName: response.data.vehicleInfo?.vehicleRegFileName,
                        documentBlobName: response.data.vehicleInfo?.vehicleRegFileId,
                        documentPath: null,
                        documentContainerName: "pit",
                        isActive: 1
                    })
                }
                if (response.data.vehicleInfo?.insuranceFileId) {
                    tempArr.push({
                        id: null,
                        documentType: "VehicleInsurance",
                        documentName: response.data.vehicleInfo?.insuranceFileName,
                        documentBlobName: response.data.vehicleInfo?.insuranceFileId,
                        documentPath: null,
                        documentContainerName: "pit",
                        isActive: 1
                    })
                }
                if (response.data.vehicleInfo?.puccFileId) {
                    tempArr.push({
                        id: null,
                        documentType: "VehiclePUCC",
                        documentName: response.data.vehicleInfo?.puccFileName,
                        documentBlobName: response.data.vehicleInfo?.puccFileId,
                        documentPath: null,
                        documentContainerName: "pit",
                        isActive: 1
                    })
                }
                if (response.data.vehicleInfo?.fitnessFileId) {
                    tempArr.push({
                        id: null,
                        documentType: "FitnessNo",
                        documentName: response.data.vehicleInfo?.fitnessFileName,
                        documentBlobName: response.data.vehicleInfo?.fitnessFileId,
                        documentPath: null,
                        documentContainerName: "pit",
                        isActive: 1
                    })
                }
                setDocumentsArray(tempArr);
                setDetails({
                    vehicleType: response.data.vehicleInfo?.vehicleType ? response.data.vehicleInfo?.vehicleType : "",
                    vehicleOwnerType: response.data.vehicleInfo?.vehicleOwnerType ? response.data.vehicleInfo?.vehicleOwnerType : "",
                    grossVehicleWeight: response.data.vehicleInfo?.grossVehicleWeight ? response.data.vehicleInfo?.grossVehicleWeight : '',
                    unladenWeight: response.data.vehicleInfo?.unladenWeight ? response.data.vehicleInfo?.unladenWeight : "",
                    vehicleMake: response.data.vehicleInfo?.vehicleMake ? response.data.vehicleInfo?.vehicleMake : "",
                    vehicleModel: response.data.vehicleInfo?.vehicleModel ? response.data.vehicleInfo?.vehicleModel : "",
                    vehicleAge: response.data.vehicleInfo?.vehicleAge ? response.data.vehicleInfo?.vehicleAge : "",
                    vehicleRegistrationNo: response.data.vehicleInfo?.vehicleRegNo ? response.data.vehicleInfo?.vehicleRegNo : details?.vehicleRegistrationNo,
                    registrationEndDate: response.data.vehicleInfo?.regEndDate ? response.data.vehicleInfo?.regEndDate : new Date(),
                    insuranceNo: response.data.vehicleInfo?.insuranceNo ? response.data.vehicleInfo?.insuranceNo : "",
                    insuranceEnddate: response.data.vehicleInfo?.insuranceEnddate ? response.data.vehicleInfo?.insuranceEnddate : new Date(),
                    puccNo: response.data.vehicleInfo?.puccNo ? response.data.vehicleInfo?.puccNo : "",
                    puccEndDate: response.data.vehicleInfo?.puccEndDate ? response.data.vehicleInfo?.puccEndDate : new Date(),
                    fitnessNo: response.data.vehicleInfo?.fitnessNo ? response.data.vehicleInfo?.fitnessNo : "",
                    fitnessEndDate: response.data.vehicleInfo?.fitnessEndDate ? response.data.vehicleInfo?.fitnessEndDate : new Date(),
                    // expectedWeight: details.expectedWeight,
                    driverName: details.driverName,
                    licenseNo: details.licenseNo,
                    driverContactNo: details.driverContactNo,
                    licenceIssueDate: details?.licenceIssueDate ? details?.licenceIssueDate : new Date(),
                    licenceValidityEnddate: details?.licenceValidityEnddate ? details?.licenceValidityEnddate : new Date(),
                    // dbsScheduleList: details.dbsScheduleList ? details.dbsScheduleList : vehicleScheduleList ? vehicleScheduleList : []
                    // dbsScheduleList: vehicleScheduleList ? vehicleScheduleList : []
                })
                setVehicleCapacity(vehicleNo === "other" ? (Number(response.data.vehicleInfo?.grossVehicleWeight) - Number(response.data.vehicleInfo?.unladenWeight)) / 1000 : "");
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const getDetailsByLicenseNo = () => {
        loaderService.showLoader();
        apiClient.post(GET_DRIVER_DETAILS_BY_LICENSE_NO,
            {
                "driverLicenseNo": otherDriverLicense
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setDetails((prev) => ({
                    ...prev,
                    driverName: response.data.driverInfo?.driverName,
                    licenseNo: response.data.driverInfo?.licenseNo,
                    driverContactNo: response.data.driverInfo?.driverContact,
                    licenceIssueDate: response.data.driverInfo?.licenseIssueDate ? response.data.driverInfo?.licenseIssueDate : new Date(),
                    licenceValidityEnddate: response.data.driverInfo?.licenseEndDate ? response.data.driverInfo?.licenseEndDate : new Date(),
                }))

                if (response.data.driverInfo?.licenseFileId) {
                    const driverDoc = {
                        id: null,
                        documentType: DRIVING_LICENSE,
                        documentName: response.data.driverInfo?.licenseFileName,
                        documentBlobName: response.data.driverInfo?.licenseFileId,
                        documentContainerName: "pit",
                        isActive: 1,
                    };
                    setDocumentsArray((prev) => {
                        const i = prev.findIndex(
                            (d) => d?.documentType === DRIVING_LICENSE
                        );
                        if (i !== -1) {
                            // update only that object; keep others as-is
                            const copy = [...prev];
                            copy[i] = { ...copy[i], ...driverDoc };
                            return copy;
                        }
                        // add it; keep existing docs
                        return [...prev, driverDoc];
                    });
                }

                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    return (
        <>
            {
                open === false &&
                <Container maxWidth="xxl">
                    {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT12</p>}
                    <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
                        {
                            localStorage.getItem('role') == PIT_ROLES.PitScmUser || localStorage.getItem('role') == PIT_ROLES.TransportationIncharge ?

                                <Typography variant="h5" gutterBottom>Consignment Creation</Typography>
                                : <Typography variant="h4">
                                    <Fab onClick={() => { navigate(-1) }} size="small" aria-label="back" title='Back'>
                                        <KeyboardArrowLeftRounded />
                                    </Fab> Consignment Creation
                                </Typography>

                        }
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
                            <>
                                <Stack direction="row" spacing={1}>
                                    <Button startIcon={<AddIcon />} sx={{ minWidth: 100 }} color="primary" variant="contained" onClick={(e) => viewurn(e, selectedConsignments)}>Create Consignment</Button>
                                </Stack>
                            </>
                        </Stack>
                    </Stack>
                    <Card>
                        <CardContent>
                            <Grid container spacing={2}>
                                {localStorage.getItem('role') == PIT_ROLES.PitScmUser || localStorage.getItem('role') == PIT_ROLES.TransportationIncharge ?
                                    <Grid item xs={12} lg={3}>
                                        <FormControl fullWidth size='small' error={noUrnError}>
                                            <InputLabel>Select URN</InputLabel>
                                            <Select label='Select URN' value={selectedUrn} onChange={(e) => onValueUrn(e)}>
                                                <MenuItem value=''>Select</MenuItem>
                                                {urnList &&
                                                    urnList.map((urns) => (
                                                        <MenuItem value={urns}>{urns}</MenuItem>
                                                    ))}
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{noUrnError}</FormHelperText>
                                        </FormControl>

                                    </Grid>
                                    : null}
                                <Grid item xs={12} lg={3}>
                                    <FormControl fullWidth >
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DesktopDatePicker
                                                label="Pick-Up Date"
                                                inputFormat="DD/MM/YYYY"
                                                value={pickUpdate}
                                                name="pickUpDate"
                                                onChange={(e) => handlePickupDateChange(e)}
                                                sx={{ width: 260 }}
                                                renderInput={(params) => <TextField size='small' {...params} />}
                                                slots={{
                                                    field: { clearButton: true },
                                                }}
                                            />
                                        </LocalizationProvider>
                                        {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            label="Pick-Up Date"
                                            inputFormat="DD/MM/YYYY"
                                            value={pickUpdate}
                                            name="pickUpDate"
                                            onChange={(e) => handleDateChange(e)}
                                            renderInput={(params) => <TextField size='small' {...params} />}
                                            slotProps={{
                                                field: { clearable: true },
                                            }}
                                        />
                                    </LocalizationProvider> */}
                                    </FormControl>
                                </Grid>
                                {/* <Grid item xs={12} lg={1}>
                                <Button variant="contained" color="primary" onClick={(e) => searchConsignmentData(e)} >
                                    Search
                                </Button>
                            </Grid> */}
                                <Grid item xs={12} lg={3}>
                                    <Button startIcon={<ClearSearchIcon />} variant="contained" color="primary" onClick={(e) => clearSearch(e)} >
                                        Clear Search
                                    </Button>
                                </Grid>
                            </Grid>
                            <Typography variant="h5" gutterBottom mt={1}>Consignment Data</Typography>
                            {
                                selectedConsignments?.length > 0 &&
                                <Paper
                                    elevation={2}
                                    sx={{
                                        p: 2,
                                        mt: 2,
                                        display: 'flex',
                                        gap: 4,
                                        backgroundColor: '#f8f9fa',
                                        alignItems: 'center'
                                    }}
                                >
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="body2" color="textSecondary">
                                                Selected Rows: <strong>{selectedConsignments.length}</strong>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}> <Typography variant="body2" color="primary">
                                            Sum of Balance Quantity: <strong>{totalQuantity.toFixed(4)} MT</strong>
                                        </Typography></Grid>
                                    </Grid>


                                </Paper>
                            }
                            <Box style={{ height: 500, width: '100%', marginTop: "2vh" }}>
                                <DataGrid
                                    rows={consignmentDetails}
                                    columns={columns}
                                    pageSize={10}
                                    getRowId={(row) => row?.id}
                                    components={{ Toolbar: QuickSearchToolbar }}
                                />
                            </Box>
                        </CardContent>
                    </Card>
                </Container>
            }
            {
                open === true &&
                <Container maxWidth="xxl">
                    <Typography variant="h5" gutterBottom>Create Consignment Details</Typography>
                    {showErrorMsg != "" &&
                        <Typography sx={{ color: 'red' }}>{showErrorMsg}</Typography>
                    }
                    <Card>
                        <CardContent>
                            <Box style={{ height: 240, width: '100%' }}>
                                <DataGrid
                                    rows={selectedConsignments}
                                    getRowId={(row) => row?.id}
                                    columns={consDetailsCol}
                                    hideFooterPagination
                                />
                                <Typography style={{ float: "right", marginRight: "27%", marginTop: "5px", color: "green" }}>Total Quantity(in MT): {totalQuantity}</Typography>
                            </Box>
                            <Grid container spacing={1} direction="row" mt={1}>
                                <Grid item xs={12}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} lg={6}>
                                            <FormControl fullWidth>
                                                <InputLabel>Vehicle Number</InputLabel>
                                                <Select
                                                    label="Vehicle Number"
                                                    value={vehicleNo}
                                                    onChange={(e) => { updateVehicleDetails(e) }}
                                                >
                                                    {vehicleList?.map(row =>
                                                        <MenuItem selected value={row.registrationNo}>{row.registrationNo}</MenuItem>
                                                    )}
                                                    <MenuItem value="other">Other</MenuItem>
                                                </Select>
                                                {vehicleNoError != "" &&
                                                    <FormHelperText sx={{ color: 'red' }}>{vehicleNoError}</FormHelperText>
                                                }
                                            </FormControl>
                                        </Grid>

                                        {vehicleNo === "other" && <>
                                            <Grid item xs={12} lg={4}>
                                                <FormControl fullWidth required error={errorMessage.vehicleType}>
                                                    <FormLabel>{t('reg.type')}</FormLabel>
                                                    <RadioGroup row>
                                                        <FormControlLabel control={<Radio id="hcv" name="vehicleType" value="HCV" checked={details?.vehicleType === "HCV"} onChange={(e) => handleChange(e)} />} label={t('preReg.hcv')} />
                                                        <FormControlLabel control={<Radio id="mcv" name="vehicleType" value="MCV" checked={details?.vehicleType === "MCV"} onChange={(e) => handleChange(e)} />} label={t('preReg.mcv')} />
                                                        <FormControlLabel control={<Radio id="lcv" name="vehicleType" value="LCV" checked={details?.vehicleType === "LCV"} onChange={(e) => handleChange(e)} />} label={t('preReg.lcv')} />
                                                    </RadioGroup>
                                                    <FormHelperText>{errorMessage.vehicleType}</FormHelperText>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} lg={4}>
                                                <FormControl fullWidth required error={errorMessage.vehicleOwnerType}>
                                                    <FormLabel>{t('preReg.ownnershipType')}</FormLabel>
                                                    <RadioGroup row>
                                                        <FormControlLabel control={<Radio id="Owned" name="vehicleOwnerType" value="Owned" checked={details?.vehicleOwnerType === "Owned"} onChange={(e) => handleChange(e)} />} label={t('preReg.owned')} />
                                                        <FormControlLabel control={<Radio id="Rented" name="vehicleOwnerType" value="Rented" checked={details?.vehicleOwnerType === "Rented"} onChange={(e) => handleChange(e)} />} label={t('preReg.rented')} />
                                                    </RadioGroup>
                                                    <FormHelperText>{errorMessage.vehicleOwnerType}</FormHelperText>
                                                </FormControl>
                                            </Grid>
                                            {/* <Grid item xs={12} lg={4}></Grid> */}
                                            <Grid item xs={12} lg={4}>
                                                <TextField fullWidth
                                                    error={errorMessage.grossVehicleWeight}
                                                    helperText={errorMessage.grossVehicleWeight}
                                                    // required
                                                    type="number"
                                                    onFocus={handleNumberFieldFocus}
                                                    label={t('reg.grossVehicleWeight')}
                                                    name="grossVehicleWeight"
                                                    value={details?.grossVehicleWeight}
                                                    onChange={(e) => handleChange(e)}
                                                    inputProps={{
                                                        maxLength: 10
                                                    }}
                                                    onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '+' || evt.key === '-') && evt.preventDefault()}
                                                />
                                            </Grid>
                                            <Grid item xs={12} lg={4}>
                                                <TextField fullWidth
                                                    // required
                                                    error={errorMessage.unladenWeight}
                                                    helperText={errorMessage.unladenWeight}
                                                    type="number"
                                                    onFocus={handleNumberFieldFocus}
                                                    label={t('reg.unladenWeight')}
                                                    name="unladenWeight"
                                                    value={details?.unladenWeight}
                                                    onChange={(e) => handleChange(e)}
                                                    inputProps={{
                                                        maxLength: 10
                                                    }}
                                                    onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '+' || evt.key === '-') && evt.preventDefault()}
                                                />
                                            </Grid>
                                            <Grid item xs={12} lg={4}>
                                                <TextField fullWidth
                                                    // required 
                                                    // error={errorMessage.vehicleMake} 
                                                    // helperText={errorMessage.vehicleMake} 
                                                    type="text"
                                                    label={t('reg.vehicleMake')}
                                                    name="vehicleMake"
                                                    value={details?.vehicleMake}
                                                    onChange={(e) => handleChange(e)}
                                                    inputProps={{
                                                        maxLength: 20
                                                    }} />
                                            </Grid>
                                            <Grid item xs={12} lg={4}>
                                                <TextField fullWidth
                                                    // required
                                                    // error={errorMessage.vehicleModel}
                                                    // helperText={errorMessage.vehicleModel}
                                                    type="text"
                                                    label={t('reg.vehicleModel')}
                                                    name="vehicleModel"
                                                    value={details?.vehicleModel}
                                                    onChange={(e) => handleChange(e)} inputProps={{
                                                        maxLength: 20
                                                    }} />
                                            </Grid>
                                            <Grid item xs={12} lg={4}>
                                                <TextField fullWidth
                                                    // required
                                                    // error={errorMessage.vehicleAge}
                                                    // helperText={errorMessage.vehicleAge}
                                                    type="number"
                                                    onFocus={handleNumberFieldFocus}
                                                    label={t('reg.vehicleAgeInYears')}
                                                    name="vehicleAge"
                                                    value={details?.vehicleAge}
                                                    onChange={(e) => handleChange(e)}
                                                    inputProps={{
                                                        maxLength: 5
                                                    }}
                                                    onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '+' || evt.key === '-') && evt.preventDefault()}
                                                />
                                            </Grid>
                                            <Grid item xs={12} lg={4}>
                                                <TextField fullWidth
                                                    error={errorMessage.vehicleRegistrationNo}
                                                    helperText={errorMessage.vehicleRegistrationNo}
                                                    label="Vehicle Registration"
                                                    name="vehicleRegistrationNo"
                                                    placeholder="Eg: AS01BYXXXX / AS01BXXXX"
                                                    value={details?.vehicleRegistrationNo}
                                                    onChange={(e) => handleChange(e)}
                                                    inputProps={{
                                                        maxLength: 20,
                                                        style: { textTransform: "uppercase" }
                                                    }}
                                                    onKeyDown={(evt) => (evt.key === '_' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                                                />
                                                <FileUploadMUI key="VehicleRegistration"
                                                    containerName="pit"
                                                    documentList={documentsArray}
                                                    documentType="VehicleRegistration"
                                                    callBackDocumentUpload={onUploadCallBack}
                                                    title={t('reg.uploadVehicleRegistrationDoc')}
                                                    stakeHolderType="Transporter"
                                                    errorMessage={errorMessage}
                                                    setErrorMessage={setErrorMessage}
                                                    documentError="registrationDocError"
                                                />
                                                {/* <div className='mandatory_field'>{errorMessage.registrationDocError}</div> */}
                                            </Grid>
                                            <Grid item xs={12} lg={4}>
                                                <FormControl fullWidth>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DesktopDatePicker
                                                            inputFormat="DD/MM/YYYY"
                                                            renderInput={(params) => <TextField {...params} />}
                                                            sx={{ minWidth: 750 }}
                                                            label={t('reg.endDate')}
                                                            minDate={new Date()}
                                                            name="registrationEndDate"
                                                            value={moment(new Date((details.registrationEndDate))).format(BASIC_DATE_FORMAT)}
                                                            onChange={(e) => handleDateChange(e, "registrationEndDate")}
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} lg={4}>
                                                <TextField fullWidth
                                                    required
                                                    error={errorMessage.insuranceNo}
                                                    helperText={errorMessage.insuranceNo}
                                                    type="text"
                                                    label={t('reg.insuranceNo')}
                                                    name="insuranceNo"
                                                    value={details?.insuranceNo}
                                                    onChange={(e) => handleChange(e)}
                                                    inputProps={{
                                                        maxLength: 20,
                                                        style: { textTransform: "uppercase" }
                                                    }} />
                                                <FileUploadMUI key="VehicleInsurance"
                                                    containerName="pit"
                                                    documentList={documentsArray}
                                                    documentType="VehicleInsurance"
                                                    callBackDocumentUpload={onUploadCallBack}
                                                    title={t('reg.uploadInsuranceDoc')}
                                                    stakeHolderType="Transporter"
                                                    errorMessage={errorMessage}
                                                    setErrorMessage={setErrorMessage}
                                                    documentError="insurenaceDocError"
                                                />
                                                {/* <div className='mandatory_field'>{errorMessage.insurenaceDocError}</div> */}
                                            </Grid>
                                            <Grid item xs={12} lg={4}>
                                                <FormControl fullWidth>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DesktopDatePicker
                                                            inputFormat="DD/MM/YYYY"
                                                            renderInput={(params) => <TextField {...params} />}
                                                            sx={{ minWidth: 750 }}
                                                            label={t('reg.endDate')}
                                                            minDate={new Date()}
                                                            name="insuranceEnddate"
                                                            value={moment(new Date((details?.insuranceEnddate))).format(BASIC_DATE_FORMAT)}
                                                            onChange={(e) => handleDateChange(e, "insuranceEnddate")}
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} lg={4}>
                                                <TextField fullWidth
                                                    required
                                                    error={errorMessage.puccNo}
                                                    helperText={errorMessage.puccNo}
                                                    type="text"
                                                    label={t('reg.puccNo')}
                                                    name="puccNo"
                                                    value={details?.puccNo}
                                                    onChange={(e) => handleChange(e)}
                                                    inputProps={{
                                                        maxLength: 20,
                                                        style: { textTransform: "uppercase" }
                                                    }} />
                                                <FileUploadMUI key="VehiclePUCC"
                                                    containerName="pit"
                                                    documentList={documentsArray}
                                                    documentType="VehiclePUCC"
                                                    callBackDocumentUpload={onUploadCallBack}
                                                    title={t('reg.uploadPuccDoc')}
                                                    stakeHolderType="Transporter"
                                                    errorMessage={errorMessage}
                                                    setErrorMessage={setErrorMessage}
                                                    documentError="puccDocError"
                                                />
                                                {/* <div className='mandatory_field'>{errorMessage.puccDocError}</div> */}
                                            </Grid>
                                            <Grid item xs={12} lg={4}>
                                                <FormControl fullWidth>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DesktopDatePicker
                                                            inputFormat="DD/MM/YYYY"
                                                            renderInput={(params) => <TextField {...params} />}
                                                            sx={{ minWidth: 750 }}
                                                            name="puccEndDate"
                                                            minDate={new Date()}
                                                            label={t('reg.endDate')}
                                                            value={moment(new Date((details?.puccEndDate))).format(BASIC_DATE_FORMAT)}
                                                            onChange={(e) => handleDateChange(e, "puccEndDate")}
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} lg={4}>
                                                <TextField fullWidth
                                                    required
                                                    error={errorMessage.fitnessNo}
                                                    helperText={errorMessage.fitnessNo}
                                                    type="text"
                                                    label={t('reg.fitnessNo')}
                                                    name="fitnessNo"
                                                    value={details?.fitnessNo}
                                                    onChange={(e) => handleChange(e)}
                                                    inputProps={{
                                                        maxLength: 20,
                                                        style: { textTransform: "uppercase" }
                                                    }} />
                                                <FileUploadMUI key="FitnessNo"
                                                    containerName="pit"
                                                    documentList={documentsArray}
                                                    documentType="FitnessNo"
                                                    callBackDocumentUpload={onUploadCallBack}
                                                    title={t('reg.uploadFitnessDoc')}
                                                    stakeHolderType="Transporter"
                                                    errorMessage={errorMessage}
                                                    setErrorMessage={setErrorMessage}
                                                    documentError="fitnessDocError"
                                                />
                                                {/* <div className='mandatory_field'>{errorMessage.fitnessDocError}</div> */}
                                            </Grid>
                                            <Grid item xs={12} lg={4}>
                                                <FormControl fullWidth>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DesktopDatePicker
                                                            inputFormat="DD/MM/YYYY"
                                                            renderInput={(params) => <TextField {...params} />}
                                                            sx={{ minWidth: 750 }}
                                                            name="fitnessEndDate"
                                                            label={t('reg.endDate')}
                                                            minDate={new Date()}
                                                            value={moment(new Date((details.fitnessEndDate))).format(BASIC_DATE_FORMAT)}
                                                            onChange={(e) => handleDateChange(e, "fitnessEndDate")}
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>
                                            </Grid>
                                            {/* <Grid item xs={12} lg={4}>
                                                <TextField fullWidth
                                                    required
                                                    error={errorMessage.expectedWeight}
                                                    helperText={errorMessage.expectedWeight}
                                                    type="number"
                                                    onFocus={handleNumberFieldFocus}
                                                    label="Expected Weight (in MT)"
                                                    name="expectedWeight"
                                                    defaultValue={totalScheduleQty}
                                                    value={details?.expectedWeight}
                                                    onChange={(e) => handleChange(e)}
                                                    inputProps={{
                                                        maxLength: 10
                                                    }}
                                                    onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '+' || evt.key === '-') && evt.preventDefault()}
                                                />
                                            </Grid> */}
                                        </>}

                                        <Grid item xs={12} lg={6}>
                                            <FormControl fullWidth>
                                                <TextField fullWidth label='Vehicle Capacity(in MT)' value={vehicleCapacity} onChange={(e) => { e.target.value.length > 0 && setVehicleCapacityError(""); setVehicleCapacity(e.target.value.slice(0, 6)) }} type="number" onFocus={handleNumberFieldFocus} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()} />
                                            </FormControl>
                                            {vehicleCapacityError != "" &&
                                                <FormHelperText sx={{ color: 'red' }}>{vehicleCapacityError}</FormHelperText>
                                            }
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <FormControl fullWidth>
                                                <InputLabel>Driver License Number</InputLabel>
                                                <Select
                                                    label="Driver License Number"
                                                    value={driverlicensenumber}
                                                    onChange={(e) => { updateDriverDetails(e) }}
                                                >
                                                    {driverList?.map(row =>
                                                        <MenuItem selected value={row.driverLicenseId}>{row.driverLicenseId}</MenuItem>
                                                    )}
                                                    <MenuItem value="other">Other</MenuItem>
                                                </Select>
                                            </FormControl>
                                            {(driverlicensenumberError != "" && driverlicensenumber !== "other") &&
                                                <FormHelperText sx={{ color: 'red' }}>{driverlicensenumberError}</FormHelperText>
                                            }
                                        </Grid>
                                        {driverlicensenumber === "other" && <Grid item xs={12} lg={6}>
                                            <FormControl fullWidth>
                                                <TextField label='Other Driver License Number'
                                                    inputProps={{
                                                        maxLength: 20
                                                    }}
                                                    value={otherDriverLicense || ''}
                                                    onChange={(e) => { e.target.value.length > 0 && setOtherDriverLicense(VALIDATION.noSpecialCharacterValidation(e.target.value)); setDriverlicensenumberError("") }}
                                                    type="text" />
                                            </FormControl>
                                            {(driverlicensenumberError != "" && driverlicensenumber === "other") &&
                                                <FormHelperText sx={{ color: 'red' }}>{driverlicensenumberError}</FormHelperText>
                                            }
                                        </Grid>
                                        }
                                        <Grid item xs={12} lg={6}>
                                            <FormControl fullWidth>
                                                <TextField label='Driver Name'
                                                    error={errorMessage.driverName}
                                                    helperText={errorMessage.driverName}
                                                    inputProps={{
                                                        maxLength: 50
                                                    }}
                                                    disabled={driverlicensenumber !== "other"}
                                                    value={details?.driverName || ''}
                                                    name='driverName'
                                                    onChange={(e) => handleChange(e)}
                                                    type="text" />
                                            </FormControl>
                                            {/* {driverNameError != "" &&
                                                <FormHelperText sx={{ color: 'red' }}>{driverNameError}</FormHelperText>
                                            } */}
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <FormControl fullWidth >
                                                <TextField label='Driver Contact'
                                                    disabled={driverlicensenumber !== "other"}
                                                    error={errorMessage.driverContactNo}
                                                    helperText={errorMessage.driverContactNo}
                                                    value={details?.driverContactNo || ''}
                                                    onChange={(e) => handleChange(e)}
                                                    type="number"
                                                    name='driverContactNo'
                                                    onFocus={handleNumberFieldFocus} />
                                            </FormControl>
                                            {/* {driverContactError != "" &&
                                                <FormHelperText sx={{ color: 'red' }}>{driverContactError}</FormHelperText>
                                            } */}
                                        </Grid>
                                        {driverlicensenumber === "other" &&
                                            <>
                                                <Grid item xs={12} lg={6}>
                                                    <FormControl fullWidth>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DesktopDatePicker
                                                                disableFuture
                                                                inputFormat="DD/MM/YYYY"
                                                                renderInput={(params) => <TextField {...params} />}
                                                                sx={{ minWidth: 750 }}
                                                                label="Licence Issued date"
                                                                name="licenceIssueDate"
                                                                value={moment(new Date((details?.licenceIssueDate))).format(BASIC_DATE_FORMAT)}
                                                                onChange={(e) => handleDateChange(e, "licenceIssueDate")}
                                                            />
                                                        </LocalizationProvider>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} lg={6}>
                                                    <FormControl fullWidth>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DesktopDatePicker
                                                                inputFormat="DD/MM/YYYY"
                                                                renderInput={(params) => <TextField {...params} />}
                                                                sx={{ minWidth: 750 }}
                                                                label="Validity End date"
                                                                name="licenceValidityEnddate"
                                                                value={moment(new Date((details?.licenceValidityEnddate))).format(BASIC_DATE_FORMAT)}
                                                                minDate={new Date()}
                                                                onChange={(e) => handleDateChange(e, "licenceValidityEnddate")}
                                                            />
                                                        </LocalizationProvider>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} lg={6}>
                                                    <FileUploadMUI key={DRIVING_LICENSE}
                                                        containerName="pit"
                                                        documentList={documentsArray}
                                                        documentType={DRIVING_LICENSE}
                                                        callBackDocumentUpload={onUploadCallBack}
                                                        // stakeholderDetailId={props.regID}
                                                        title={t('reg.uploadDrivingLicenseDoc')}
                                                        stakeholderType="Transporter"
                                                        errorMessage={errorMessage}
                                                        setErrorMessage={setErrorMessage}
                                                        documentError="drivingLicenseDocError"
                                                    />
                                                </Grid>
                                            </>}
                                        <Grid item xs={12} lg={6}>
                                            <TextField fullWidth
                                                autoComplete="off"
                                                id="outlined-multiline-static"
                                                label={t('reg.comment')}
                                                multiline
                                                inputProps={{ maxLength: 500 }}
                                                type="text"
                                                onChange={(e) => onTextValueChange(e)}
                                                value={comments}
                                            />
                                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <Badge bg={`${comments?.length > characterLimit ? 'danger' : 'primary'}`}>{comments?.length}/{characterLimit}</Badge>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                    <Box display='flex' alignItems="center" justifyContent="center" mt={3} mb={1} style={{ float: "right" }}>
                        <Button variant='outlined' sx={{ minWidth: 100 }} onClick={handleClose} startIcon={<CloseIcon />} >Cancel</Button>
                        <Button variant='contained' sx={{ minWidth: 100, ml: 1 }} onClick={onSaveButtonClick} startIcon={<SaveIcon />} >Save</Button>
                    </Box>
                </Container>
            }

            <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
                <DialogContent>
                    <ConfirmPopover title={cofirmMessage} hideLink={true} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setLogModalOpen(false)}>OK</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={open1}
                onClose={handleClose1}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"

            >
                <DialogTitle id="alert-dialog-title"  >
                    <Typography variant='subtitle1' gutterBottom>Split Consignment</Typography>
                </DialogTitle>
                <DialogContent>
                    <Typography>Vehicle capacity is less than the total Quantity. Do you want to split ?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose1} autoFocus>No</Button>
                    <Button onClick={handleYes}>Yes</Button>


                </DialogActions>
            </Dialog>

            <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirm} onClose={handleConfirmClose} action="Create Consignment" />

        </>
    )
}